export default __webpack_public_path__ + "static/media/3453.811dcb21.png";